import React from 'react'
import { Skeleton, SkeletonText, Stack } from "@chakra-ui/react"

export default function BlogDetailsSkeleton() {

    return (
    <Stack  width="100%" mb={5}>
        <Skeleton height="60vh" width="100%"  />
        <SkeletonText mt="4" noOfLines={5} spacing="3"  />
        <Skeleton height="40vh" width="60%" m="auto" ml={10} />
        <SkeletonText mt="8" noOfLines={7} spacing="3"  />
    </Stack>
    )
}
